export default {
  fade: "basic-fade",
  fadeAndMoveLeft: "fade-and-move-left",
};
